/**
 * nuxtClientInit is based on https://github.com/nuxt/nuxt.js/issues/240#issuecomment-326893386
 */
export default async (context) => {
	await context.store.dispatch('nuxtClientInit', context)
}
